var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"cultureWaterGold"},_vm._l((_vm.itemList),function(item){return _c('WaterGoldItem',{key:item.title,attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }